import script from "./goRinSyo0032.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0032.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0032.vue?vue&type=style&index=0&id=4e9523bd&lang=scss"

const __exports__ = script;

export default __exports__